export default __webpack_public_path__ + "static/media/regulatory--no-motor-vehicles-or-buses--g1.8e58f8bf.png";